module.exports = __webpack_public_path__ + "img/dinapoliHeader.a120a015.png";